import React, { useState, useEffect, useRef } from "react"; 
const EditableCell = ({
    value: initialValue,
    row: { index, original },
    column: { id },
    CellChangeCallback, // This is a custom function that we supplied to our table instance
}) => {
    // We need to keep and update the state of the cell normally
    const [value, setValue] = React.useState(initialValue)
    const [done, setDone] = useState(false)
    const [editable, setEditable] = useState(false)
    const transientValue = useRef(initialValue);

    const onChange = e => {
        setValue(e.target.value)
    }
    // We'll only update the external data when the input is blurred
    const onBlur = () => {
        if (value && transientValue.current !== value) {
            setValue(initialValue)
            CellChangeCallback(id, original, value)
            transientValue.current = value;
        }
        setEditable(false)
    }
    
    useEffect(() => {
        setValue(initialValue)
    },[initialValue])

    return (
        <>
            {!editable?
                <span className="p-3" onMouseOver={() => { setDone(false) }}>{value} <small><i className="far fa-edit display-8 text-success" onClick={()=>setEditable(true)}></i></small></span> 
            :
                <input type="time" autoFocus className="form-control mx-auto text-center w-100" value={value || ""} onChange={onChange} onBlur={onBlur}/>
            } 
        </>
    )
}

export default EditableCell